import React from 'react';
import './QuickActionCard.css';

const QuickActionCard = (props) => {
    return (
        <div className="qac-card">
            <div className="qac-icon-wrap">
                {props.icon}
            </div>
            <p className="qac-label">{props.label}</p>
        </div>
    );
};

export default QuickActionCard;